import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    /** 获取管理员信息列表 **/
    GET_MANAGER_LIST(data) {
        controller='Manager';
        action='GetManagerList';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 删除管理员信息 **/
    DEL_MANAGER(data) {
        controller='Manager';
        action='DelManager';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取管理员角色信息 **/
    GET_GROUP_LIST(data) {
        controller='Manager';
        action='GetGroupList';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 新增管理员信息 **/
    ADD_MANAGER(data) {
        controller='Manager';
        action='AddManager';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取管理员信息详情 **/
    GET_MANAGER_INFOS(data) {
        controller='Manager';
        action='GetManagerInfos';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 编辑管理员信息 **/
    EDIT_MANAGER(data) {
        controller='Manager';
        action='EditManager';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取角色信息列表 **/
    GET_MANAGER_ROLE(data) {
        controller='Manager';
        action='GetManagerRole';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 删除角色信息 **/
    DEL_MANAGER_ROLE(data) {
        controller='Manager';
        action='DelRole';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 新增、编辑角色信息 **/
    ADD_OR_EDIT_ROLE(data) {
        controller='Manager';
        action='AddOrEditRole';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取角色权限信息 **/
    GET_GROUP_AUTH(data) {
        controller='Manager';
        action='GetGroupAuth';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 保存角色权限信息 **/
    UPDATE_GROUP_AUTH(data) {
        controller='Manager';
        action='UpdateGroupAuth';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    }

}